import {
  LOGOUT,
  INVITE_SUCCESS,
  INVITE_FAILURE,
  RESET_INVITE,
  PARTNER_DETAILS_FETCHED,
  SECRETCODE_SUCCESS,
  FAILED_TO_FETCH_PARTNER,
  SET_PARTNER_ONLINE,
  SET_PARTNER_ADDRESS,
} from "../types/types"
import _ from "../../utils/lodashUtils"

const initialState = {
  loading: true,
  isInvited: null,
  partnerDetails: null,
  confirmed: false,
  invitationType: null,
  partnerContact: "",
}

export default function (state = initialState, action) {
  const { type, payload, nickName, invitationType, partnerContact } = action

  switch (type) {
    case INVITE_SUCCESS:
      return {
        ...state,
        ...payload,
        partnerDetails: payload.data,
        nickName: nickName,
        invitationType: invitationType,
        partnerContact: partnerContact,
        isInvited: true,
        loading: false,
      }

    case INVITE_FAILURE:
      return {
        ...state,
        isInvited: false,
        loading: false,
      }
    case RESET_INVITE:
      return {
        ...state,
        isInvited: false,
        loading: false,
        confirmed: true,
      }
    case PARTNER_DETAILS_FETCHED:
      return {
        ...state,
        partnerDetails: payload,
        invitationType: payload.invite_type,
      }
    case SECRETCODE_SUCCESS:
      return {
        ...state,
        partnerDetails: payload,
      }
    case FAILED_TO_FETCH_PARTNER:
      return {
        ...initialState,
      }
    case LOGOUT:
      return {
        ...initialState,
      }
    case SET_PARTNER_ONLINE:
      const partnerDetails = state.partnerDetails
      return {
        ...state,
        partnerDetails: {
          ...partnerDetails,
          dating_status: "ACTIVE",
        },
      }
    case SET_PARTNER_ADDRESS:
      const partnerDetailsForAddress = state.partnerDetails
      const partner2 = _.get(state, "partnerDetails.partner2", {})
      return {
        ...state,
        partnerDetails: {
          ...partnerDetailsForAddress,
          partner2: {
            ...partner2,
            address: payload,
          },
        },
      }
    default:
      return state
  }
}
